import formatDate from '@functions/date-functions';
import { useDeleteRecipeNote } from '@hooks/customer/useDeleteRecipeNote';
import { NoteProps } from '@hooks/customer/useRecipeNotes';
import { recipeNoteDeleted } from '@repo/ui/src/services/analytics';
import { AccordionItem } from '@repo/ui/src/components/Accordion';

export interface SegmentRecipeProps {
  recipe_name: string;
  recipe_url: string;
  recipe_image_url: string;
  recipe_author_name: string;
  pellet_recommendation: string;
  recipe_serving_size: number;
  recipe_measurement_units: string;
  recipe_prep_time: number;
  recipe_cook_time: number;
  featuredProducts: Record<string, any>[] | null;
  recipe_author_id: string;
  effort: string;
  recipe_type?: string;
}

interface Props {
  note: NoteProps;
  recipeId: string;
  showEditForm: (note: NoteProps) => void;
  segmentRecipe: SegmentRecipeProps;
}

export const RecipeNote = ({ note, recipeId, showEditForm, segmentRecipe }: Props) => {
  const { trigger: deleteNote } = useDeleteRecipeNote({ recipeId });
  const title = formatDate(note.createdAt);

  return (
    <AccordionItem key={note.id} uuid={note.id} heading={title}>
      <div className="tw-grid tw-gap-y-6">
        <p className="tra-text-web-body-l">{note.comment}</p>
        <div className="tw-flex tw-gap-x-3">
          <button onClick={() => showEditForm(note)} className="tra-text-web-body-l-link">
            Edit
          </button>
          <button
            onClick={() => {
              deleteNote({ id: note.id });
              recipeNoteDeleted({
                ...segmentRecipe,
                note_id: note?.id,
                featured_products: segmentRecipe.featuredProducts,
                recipe_id: recipeId,
              });
            }}
            className="tra-text-web-body-l-link"
          >
            Delete
          </button>
        </div>
      </div>
    </AccordionItem>
  );
};
